import { GeoJSON, Marker } from 'react-leaflet';
import { shallowEqual } from 'react-redux';
import Map from '../../../../../../shared/components/map/Map';
import { getMarkerIcon } from '../../../../adMarkerBuilder';
import { areaMarkerUrl, dpeCombinedMarkerUrl } from '../../../../constant';
import { useAppSelector } from '../../../../../../App/redux/store';
import { getAdState } from '../../../../adSlice';
import styles from './similarPlotResult.module.scss';

import { FormControlLabel, Radio } from '@material-ui/core';
import UrbaneaseButton from '../../../../../../components/linksToUrbanease/UrbaneaseButton';
import { ReactComponent as PictoPlace } from '../../../../../../images/picto-place.svg';
import { ReactComponent as PictoSurface } from '../../../../../../images/picto-surface.svg';
import StreetViewLink from './StreetViewLink';
import { useRadioButtonStyles } from './muiStyles';
interface ISimilarPlotResultCardProps {
  adPlot: AdPlot;
  index: number;
  isHighlighted: boolean;
  onRadioClick: (address: string) => void;
}
function SimilarPlotResultCard({
  adPlot,
  isHighlighted,
  onRadioClick,
}: ISimilarPlotResultCardProps) {
  const { similarAdDpes } = useAppSelector(getAdState, shallowEqual);
  const coord = adPlot.coordinates;

  if (!coord || !adPlot.address) return null;

  const department = adPlot.fullPlotId.substring(0, 2);

  // Determine if this plot should use the combined marker
  const plotAddress = adPlot.address.toLowerCase().trim();
  const hasCombinedDpe = (similarAdDpes.result ?? []).some(
    (d) => d.isGeoAddress && d.address?.toLowerCase().trim() === plotAddress,
  );
  const markerUrl = hasCombinedDpe ? dpeCombinedMarkerUrl : areaMarkerUrl;
  const fillColor = hasCombinedDpe ? 'red' : 'yellow';

  return (
    <div
      id={adPlot.fullPlotId}
      className={`${styles.similarPlotResultCard} ${
        isHighlighted ? styles.highlighted : ''
      }`}
    >
      <Map
        center={adPlot.coordinates}
        className={styles.map}
        isSatellite
        zoom={16}
        markers={[
          <Marker
            key={adPlot.fullPlotId}
            position={[coord.lat, coord.lng]}
            icon={getMarkerIcon(markerUrl)}
          />,
        ]}
        geoJson={
          <GeoJSON
            data={
              {
                type: 'Feature',
                geometry: adPlot.geometry,
                properties: {},
              } as GeoJSON.Feature
            }
            key={adPlot.fullPlotId}
            style={{
              fillColor: fillColor,
              weight: 3,
              color: fillColor,
              fillOpacity: 0.4,
            }}
          />
        }
      />
      <div className={styles.infos}>
        <p>
          <PictoPlace width="16" height="20" /> <span>Lieu</span>
          {':'}
          {adPlot.address ? (
            <StreetViewLink
              lat={coord.lat}
              lng={coord.lng}
              address={adPlot.address}
            />
          ) : (
            'indéfinie'
          )}
        </p>
        <p>
          <PictoSurface width="16" height="20" />
          <span>Emprise au sol du bâti</span>
          {` : ${adPlot.builtArea} m²`}
        </p>
        <p>
          <PictoSurface width="16" height="20" />
          <span>Surface du terrain</span>
          {` : ${adPlot.landArea} m²`}
        </p>
        <FormControlLabel
          value={adPlot.address}
          control={
            <Radio
              classes={useRadioButtonStyles()}
              onClick={() => onRadioClick(adPlot.address)}
            />
          }
          label="Sélectionnez cette adresse pour enregistrer l’annonce"
        />

        <UrbaneaseButton department={department} lat={coord.lat} lng={coord.lng} />
      </div>
    </div>
  );
}

export default SimilarPlotResultCard;
